import React, { useRef, useEffect } from 'react';
import { Popper } from '@mui/material';
import AddBlock from './AddBlock';

interface AddBlockPopperProps {
	scrollPosition: { scrollLeft: number; scrollTop: number };
	canvasDimensions: { width: number; height: number };
	onStageChange?: (stage: number) => void;
}

const AddBlockPopper: React.FC<AddBlockPopperProps> = ({
	scrollPosition,
	canvasDimensions,
	onStageChange,
}) => {
	const anchorRef = useRef<HTMLDivElement>(null);
	const [canvasElement, setCanvasElement] = React.useState<HTMLElement | null>(
		null
	);

	useEffect(() => {
		const canvas = document.getElementById('main-canvas');
		if (canvas) {
			setCanvasElement(canvas);
		}
	}, []);

	useEffect(() => {
		if (anchorRef.current) {
			anchorRef.current.style.left = `${scrollPosition.scrollLeft + 15}px`;
			anchorRef.current.style.top = `${scrollPosition.scrollTop + canvasDimensions.height - 20}px`;
		}
	}, [
		scrollPosition.scrollLeft,
		scrollPosition.scrollTop,
		canvasDimensions.height,
	]);

	return (
		<>
			<div
				ref={anchorRef}
				style={{
					position: 'absolute',
					width: 1,
					height: 1,
					pointerEvents: 'none',
				}}
			/>

			<Popper
				open={true}
				anchorEl={anchorRef.current}
				placement="top-start"
				disablePortal={true}
				style={{
					zIndex: 1000,
					pointerEvents: 'auto',
				}}
				modifiers={[
					{
						name: 'preventOverflow',
						options: {
							boundary: canvasElement || 'viewport',
							padding: 20,
						},
					},
					{
						name: 'flip',
						options: {
							fallbackPlacements: ['top-end', 'bottom-start', 'bottom-end'],
						},
					},
				]}
			>
				<div>
					<AddBlock onStageChange={onStageChange} />
				</div>
			</Popper>
		</>
	);
};

export default AddBlockPopper;
